(() => {
  const body = document.body;
  const header = document.querySelector('[data-zx-header]');
  const menu = document.querySelector('[data-zx-mobile-menu]');
  const toggle = document.querySelector('[data-zx-menu-toggle]');
  const closeButtons = document.querySelectorAll('[data-zx-menu-close]');

  const setMenu = (open) => {
    if (!menu || !toggle) return;
    const openLabel = toggle.dataset.openLabel || 'Open menu';
    const closeLabel = toggle.dataset.closeLabel || 'Close menu';
    body.classList.toggle('zx-menu-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? closeLabel : openLabel);
    menu.setAttribute('aria-hidden', String(!open));
    menu.inert = !open;

    if (open) {
      const firstLink = menu.querySelector('a');
      window.setTimeout(() => firstLink?.focus(), 180);
    } else {
      toggle.focus({ preventScroll: true });
    }
  };

  toggle?.addEventListener('click', () => {
    setMenu(toggle.getAttribute('aria-expanded') !== 'true');
  });

  closeButtons.forEach((button) => button.addEventListener('click', () => setMenu(false)));
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && body.classList.contains('zx-menu-open')) setMenu(false);
  });

  const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 18);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  const revealItems = document.querySelectorAll('.zx-reveal');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver((entries, activeObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        activeObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  const hashLinks = document.querySelectorAll('a[href^="#"]');
  hashLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const targetId = link.getAttribute('href');
      if (!targetId || targetId === '#') return;
      const target = document.querySelector(targetId);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      history.replaceState(null, '', targetId);
    });
  });

  const publishZXEvent = (eventName, details = {}) => {
    if (!eventName) return;
    const payload = {
      event_name: eventName,
      model: details.model || undefined,
      locale: document.documentElement.lang || undefined,
      page_path: window.location.pathname,
      page_type: document.body.className.match(/template-([^\s]+)/)?.[1] || undefined
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'zx_' + eventName, ...payload });

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'zx_' + eventName, payload);
    }

    if (window.Shopify?.analytics?.publish) {
      Promise.resolve(window.Shopify.analytics.publish('zxmoto:' + eventName, payload)).catch(() => {});
    }

    document.dispatchEvent(new CustomEvent('zxmoto:tracking', { detail: payload }));
  };

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-zx-event]');
    if (!target || target.dataset.zxEvent === 'contact_form_submit') return;
    publishZXEvent(target.dataset.zxEvent, { model: target.dataset.zxModel });
  });

  const contactForm = document.querySelector('#ZXContactForm');
  if (contactForm) {
    const params = new URLSearchParams(window.location.search);
    const enquiryField = contactForm.querySelector('[name="enquiry"]');
    const modelField = contactForm.querySelector('[name="model"]');
    const requestedEnquiry = params.get('enquiry') || contactForm.dataset.defaultEnquiry;
    const requestedModel = params.get('model');

    if (requestedEnquiry && enquiryField?.querySelector('option[value="' + CSS.escape(requestedEnquiry) + '"]')) {
      enquiryField.value = requestedEnquiry;
    }
    if (requestedModel && modelField?.querySelector('option[value="' + CSS.escape(requestedModel) + '"]')) {
      modelField.value = requestedModel;
    }

    contactForm.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!contactForm.reportValidity()) return;

      const formData = new FormData(contactForm);
      const language = contactForm.dataset.language === 'ar' ? 'ar' : 'en';
      const model = String(formData.get('model') || '');
      const enquiryLabel = enquiryField?.selectedOptions?.[0]?.textContent?.trim() || '';
      const lines = language === 'ar'
        ? [
            'طلب جديد من موقع ZXMOTO UAE',
            'الاسم: ' + formData.get('name'),
            'رقم واتساب: ' + formData.get('whatsapp'),
            formData.get('email') ? 'البريد الإلكتروني: ' + formData.get('email') : '',
            'نوع الاستفسار: ' + enquiryLabel,
            model ? 'الطراز: ' + model : '',
            formData.get('message') ? 'الرسالة: ' + formData.get('message') : '',
            'الصفحة: ' + window.location.href
          ]
        : [
            'New enquiry from the ZXMOTO UAE website',
            'Name: ' + formData.get('name'),
            'WhatsApp number: ' + formData.get('whatsapp'),
            formData.get('email') ? 'Email: ' + formData.get('email') : '',
            'Enquiry: ' + enquiryLabel,
            model ? 'Model: ' + model : '',
            formData.get('message') ? 'Message: ' + formData.get('message') : '',
            'Page: ' + window.location.href
          ];

      publishZXEvent('contact_form_submit', { model });
      const whatsappUrl = 'https://wa.me/971567907199?text=' + encodeURIComponent(lines.filter(Boolean).join('\n'));
      window.open(whatsappUrl, '_blank', 'noopener');
    });
  }
})();
